import { render } from "./ThePriceCompetitorFilters.vue?vue&type=template&id=56ae46b0"
import script from "./ThePriceCompetitorFilters.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitorFilters.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__